import Pagination from "../common/Pagination";
import React from "react";

export const Grid = ({ currentRecords, totalPages, currentPage, onPageChange, translationMap }) => {
  const handlePageChange = (page) => {
    onPageChange(page);
  };
  return (
    <>
            <div id="tableGrid" className="table-container">
                <table>
                    <thead>
                    <tr>
                        <th>{translationMap?.sptrn || "SPTRN"}</th>
                        <th>{translationMap?.degtrn || "DEGTRN"}</th>
                        <th>{translationMap?.transaction_date || "Transaction Date"}</th>
                        <th>{translationMap?.payment_status || "Payment Status"}</th>
                        <th>{translationMap?.amount || "Amount"}</th>
                        <th>{translationMap?.payment_method || "Payment Method"}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentRecords.map((item, index) =>
            <tr key={index}>
                            <td>{item?.SPTRN}</td>
                            <td>{item?.ReturnDEGTRN}</td>
                            <td>{item?.DFECTransactionDate}</td>
                            <td>{item.PaymentStatus?.toUpperCase()}</td>
                            <td>{Number(item?.Amount)}</td>
                            <td>{item?.ReturnPymtMethod}</td>
                        </tr>
            )}
                    </tbody>
                </table>
            </div>
            {totalPages > 1 &&
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange} />


      }
        </>);

};